import { DeleteButton, AccessCheck } from "@components";
import { UserRoleEnum } from "features/users/types";
import { workspacesService } from "features/workspaces/services/workspaces-service";

export const DeleteWorkspaceButton = ({ id }: { id: number }) => (
  <AccessCheck minAccessLevel={UserRoleEnum.Owner} showAlert={false}>
    <DeleteButton id={id} deleteService={workspacesService.deleteWorkspace} label="Workspace" />
  </AccessCheck>
);
